{
  "title": "Monitors",
  "add": "Add a monitor",
  "create": "Create the monitor",
  "edit": "Edit",
  "enable": "Enable",
  "disable": "Disable",
  "off": "off",
  "emptyTitle": "No monitors",
  "emptyHint": "Without a monitor the node stays grey: the platform does not check it and does not know whether it is up. The simplest check is ICMP to the node address.",
  "deleteConfirm": "Delete this monitor? The check history is kept.",
  "kindLabel": "Check type",
  "kindFixed": "The type does not change: delete the monitor and create a new one",
  "target": "Target",
  "targetPlaceholder": "the node address",
  "targetHint": "empty — the node address is used",
  "targetRequired": "the node has no address, so a target is required",
  "interval": "Interval, s",
  "intervalHint": "at least {{min}}",
  "timeout": "Timeout, ms",
  "failThreshold": "Down threshold",
  "failThresholdHint": "failures in a row",
  "okThreshold": "Up threshold",
  "okThresholdHint": "successes in a row",
  "timeoutTooBig": "The timeout must not exceed the interval: otherwise checks overlap each other.",
  "everySeconds": "every {{seconds}} s",
  "timeoutMs": "timeout {{ms}} ms",
  "thresholds": "threshold {{fail}}/{{ok}}",
  "inStateSince": "in this state since {{at}}",
  "checkRequested": "The check was requested — the result arrives in a few seconds.",
  "checkNowHint": "The result arrives by telemetry in a few seconds",
  "checkNowDisabled": "A disabled monitor is not checked",
  "noChecksYet": "no checks yet",
  "offNoChecks": "off, no checks",
  "checkedAgo": "checked {{ago}} · {{at}}",
  "overdue": "longer than usual",
  "rtt": "{{value}} ms",
  "http": {
    "path": "Path",
    "expectStatus": "Expected codes",
    "commaSeparated": "comma-separated",
    "followRedirects": "Follow redirects",
    "expectBody": "Substring in the body",
    "expectBodyHint": "empty — the body is not checked"
  },
  "snmp": {
    "oidHint": "digits separated by dots",
    "version": "Version",
    "expectValue": "Expected value",
    "expectValueHint": "empty — an answer alone is enough"
  },
  "chart": {
    "label": "Response over an hour{{peak}}, {{view}}",
    "peakSuffix": ", peak {{value}} ms",
    "hour": "hour",
    "hourPeak": "hour · peak {{value}} ms",
    "bars": "Bars",
    "line": "Line",
    "noRecentData": "no checks in the last hour"
  }
}
